import initModulesInScope from "@elements/init-modules-in-scope";
import {clearAll, showNotification} from "@elements/alert-notification";
import $ from "jquery";

export default function asyncAppend({
                                        $target,
                                        $loading = $(),
                                        $notifications = $()
                                    }, request) {

    request = request.then(response => (response.json && typeof response.json === 'function')
        ? response.json()
        : response
    );

    $target.attr('hidden', null);
    $loading.attr('hidden', null);

    if (hasElements($notifications)) {
        clearAll({
            $container: $notifications
        });
    }

    // always show notification even if no specific notification container is provided
    showNotification(request, {
        $container: $notifications
    });

    request.catch((error, requestState) => {
        $loading.attr('hidden', 'hidden');
    })

    return request
        .then(response => (response.json && typeof response.json === 'function')
            ? response.clone().json()
            : response
        )
        .then(function (result) {
            let content = result.html || result.content;
            if (content && result.success !== false) {
                $target.empty().append(content);
                initModulesInScope($target);
            }

            $loading.attr('hidden', 'hidden');
            return result;
        });
}


function hasElements($element) {
    return $element && $element.length;
}

function call(fnc, ...params) {
    if (fnc && typeof fnc === 'function') {
        fnc(...params);
    }
}
